<div class="pages-modal analise-propostas-cotacao-modal ui-fluid">
    <ng-content select="[componentOverlay]"></ng-content>
    
    <p-popover #overlay (onHide)="onHideOnAction($event)">
        <div class="grid grid-cols-12 pd-3 gap-x-4 gap-y-1 text-center mb-8">
            <div class="col-span-12">
                <app-datatable [items]="items"
                    [columns]="columns"
                    [lazy]="lazy"
                    [paginator]="paginator"
                    [paginatorModel]="paginatorModel"
                    [rows]="rowsDataTable"
                    [captionText]="captionText"
                    (onLoadItems)="onLoadItemsAction($event)"
                    [loading]="loadingDataTable"
                    [selectionMode]="selectionMode"
                    (onFilterItems)="onFilterItemsAction($event)"
                    (onSelectItems)="selectItemsOnAction($event)"
                    [setResetItemsSelect]="isResetItemsSelect"
                    [query]="query"
                    [showFilter]="showFilter"
                    [showAdvancedFilter]="false"
                    [showExports]="showExports">
                    <ng-template #contentColumnActions let-item="item" let-index="index">
                        <ng-container
                            [ngTemplateOutlet]="contentColumnActionsOverlay"
                            [ngTemplateOutletContext]="{item: item, index: index}">
                        </ng-container>
                    </ng-template>
                </app-datatable>
            </div>

            <div class="col-span-12">
                <ng-content select="[contentFooterOverlay]"></ng-content>
            </div>
        </div>    
    </p-popover>
</div>